import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Select } from "antd";
// FILTERS
import FilterSearchText from "../filters/FilterSearchText";
// INTERFACES
import { FormularyHeaderInputSelectKeyValueInterface } from "../../../interfaces/Global.interface";

export default function FormularyHeaderInputSelectKeyValue({
	columnName,
	inputPlaceholder,
	formAction,
	value,
	onChangeFormValue,
	variableName,
	itemId,
	values,
	onClickCellName = () => {},
	enabledCellClick = false,
	enabledFilter = false,
	filterValue = "",
	setFilterValue = () => {},
	refreshTable = () => {},
}: FormularyHeaderInputSelectKeyValueInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Column, ColumnGroup } = Table;
	const { Option } = Select;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const getItemName = (recordId: string) => {
		const item = values.find((v: any) => v.id === recordId);
		return item ? item.name : "--";
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<ColumnGroup title={columnName}>
			<Column
				className='generalStyles__hoverCursor'
				onCell={(record: any) => ({
					onClick: () => {
						if (enabledCellClick && formAction === "create") {
							onClickCellName(record);
						}
					},
				})}
				filterDropdown={() => (
					<>
						{enabledFilter && (
							<FilterSearchText
								placeHolder={inputPlaceholder}
								filterValue={filterValue}
								setFilterValue={setFilterValue}
								refreshTable={refreshTable}
								refreshRequireParamenters
							/>
						)}
					</>
				)}
				filterIcon={enabledFilter ? undefined : () => null}
				title={
					<Select
						optionFilterProp='children'
						allowClear={false}
						size='small'
						value={formAction === "create" ? value : null}
						disabled={formAction === "edit" || values.length === 0}
						className='generalStyles__width100'
						placeholder={inputPlaceholder}
						onChange={(e: string | number) => {
							onChangeFormValue(e, variableName);
						}}
					>
						{values.map((item: any) => (
							<Option key={item.id} value={item.id}>
								{item.name}
							</Option>
						))}
					</Select>
				}
				dataIndex={variableName}
				key={variableName}
				render={(text, record: any) => (
					<div>
						{formAction === "edit" && record.id === itemId ? (
							<Select
								optionFilterProp='children'
								allowClear={false}
								size='small'
								value={value}
								className='generalStyles__width100'
								placeholder={inputPlaceholder}
								onChange={(e: string | number) => {
									onChangeFormValue(e, variableName);
								}}
							>
								{values.map((item: any) => (
									<Option key={item.id} value={item.id}>
										{item.name}
									</Option>
								))}
							</Select>
						) : (
							<div>{getItemName(text)}</div>
						)}
					</div>
				)}
			/>
		</ColumnGroup>
	);
}
